var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.25C10.2051 12.25 8.75 13.7051 8.75 15.5C8.75 17.2949 10.2051 18.75 12 18.75C13.7949 18.75 15.25 17.2949 15.25 15.5C15.25 13.7051 13.7949 12.25 12 12.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.5C10.75 5.80964 11.3096 5.25 12 5.25C12.6904 5.25 13.25 5.80964 13.25 6.5C13.25 7.19036 12.6904 7.75 12 7.75C11.3096 7.75 10.75 7.19036 10.75 6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM7.25 15.5C7.25 18.1234 9.37665 20.25 12 20.25C14.6234 20.25 16.75 18.1234 16.75 15.5C16.75 12.8766 14.6234 10.75 12 10.75C9.37665 10.75 7.25 12.8766 7.25 15.5ZM12 3.75C10.4812 3.75 9.25 4.98122 9.25 6.5C9.25 8.01878 10.4812 9.25 12 9.25C13.5188 9.25 14.75 8.01878 14.75 6.5C14.75 4.98122 13.5188 3.75 12 3.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.f5a6798d459097de2b94bc6eb176bb6f.svg";
export { ForwardRef as ReactComponent };